export const peopleProperties: { [key: string]: string } = {
  name: 'name',
  role: 'role',
  rank: 'Rank',
  email: 'email',
  location: 'location',
  subServiceLine: 'subServiceLine',
  pictureUrl: 'pictureUrl',
  vertical: 'vertical',
  detailPath: 'detailPath',
  aboutme: 'aboutme',
  accountId: 'accountId',
  hitHighlightedProperties: 'HitHighlightedProperties',
  excerpt: 'HitHighlightedSummary',

  cv:'ESC_ENRICHUSERCV',
  
  engagementHistoryGlobal:'ESC_ENGAGEMENTHISTORYGLOBAL',
  engagementHistorySector:'ESC_ENGAGEMENTHISTORYSECTOR',
  engagementHistoryServicePerformed:'ESC_ENGAGEMENTHISTORYSERVICEPERFORMED',
  engagementHistorySubSector:'ESC_ENGAGEMENTHISTORYSUBSECTOR',
  engagementHistoryServiceLine:'ESC_ENGAGEMENTHISTORYSUBSERVICELINE',
  certifications:'ESC_CERTIFICATION',

  knowledgeTitle:'ESC_ENRICHDATA.ESC_TITLE',
  knowledgeAbstract:'ESC_ENRICHDATA.ESC_EYABSTRACT',

  credentialTitle:'ESC_ENRICHCREDDATA.ESC_TITLE',
  credentialEYApproach:'ESC_ENRICHCREDDATA.ESC_EYAPPROACH',
  credentialFileContentBody:'ESC_ENRICHCREDDATA',

  platBadge:'ESC_PLAT_BADGE_SUBDOMAIN',
  gldBadge:'ESC_GLD_BADGE_SUBDOMAIN',
  slvBadge:'ESC_SLV_BADGE_SUBDOMAIN',
  brzBadge:'ESC_BRZ_BADGE_SUBDOMAIN',
  otherBadge:'ESC_OTHER_BADGE_SUBDOMAIN',

  askmeAbout:'ESC_ASKMEABOUT'
  //updates
};